// @version V0.0.1 [Wednesday - 20201028_093557] : init

import Vue from 'vue';

// Vuex
import Vuex from 'vuex'
Vue.use(Vuex)
import VuexProperties from './../asahi/vuex'
export const store = new Vuex.Store(VuexProperties)
